import { render } from "./Logo.vue?vue&type=template&id=d4e32588"
const script = {}

import exportComponent from "/var/docker/processing-orders/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__